import { DestinationTaskConfigBase } from '../config-objects/destination-service-config-base';
import { IfRuleGroup } from './if-rule-group';

/**
 * Configuration for an IfGate task — evaluates ordered condition groups against each record
 * and routes to different branches based on which group matches first.
 *
 * Routing:
 * - First matching group → `rules[N].successMappingID`
 * - No group matches → `IfGateConfig.successMappingID` (default/else branch)
 * - Evaluation error → `IfGateConfig.failureMappingID` (error branch)
 */
export class IfGateConfig extends DestinationTaskConfigBase {
	/**
	 * Ordered array of condition groups. Groups are evaluated sequentially; the first group
	 * whose conditions pass wins and the record is routed to that group's successMappingID.
	 */
	rules: IfRuleGroup[] = [];

	constructor(init?: Partial<IfGateConfig>) {
		super(init);
		if (init) {
			Object.assign(this, init);
		}
	}

	override GetDestinationTasks(): string[] {
		const taskDestination: string[] = super.GetDestinationTasks();
		this.rules.forEach(rule => {
			const temp = new IfRuleGroup(rule);
			taskDestination.push(...temp.GetDestinationTasks());
		});
		return taskDestination;
	}
}
